/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationSentimentKind =
  (typeof GroupByConversationSentimentKind)[keyof typeof GroupByConversationSentimentKind];

export const GroupByConversationSentimentKind = {
  conversation_sentiment: 'conversation_sentiment',
} as const;
